import React from 'react'

function ModeChanger(props) {
    const moon = <ion-icon name="moon-outline"></ion-icon>;
    const sun = <ion-icon name="sunny-outline" ></ion-icon>;
    return (
        <div className="dropdown position-fixed bottom-0 end-0 mb-3 me-3">
            <button className="btn py-2 dropdown-toggle d-flex align-items-center" id="bd-theme" type="button" aria-expanded="false" data-bs-toggle="dropdown" aria-label="Toggle theme (auto)" style={{ backgroundColor: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1", color: !props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9", zIndex: 5 }}>{props.mode === "light" ? sun : moon}</button>
            <ul className={`dropdown-menu dropdown-menu-end bg-${props.mode === "light" ? "light" : "light"}`} aria-labelledby="bd-theme-text" data-popper-placement="top-end">
                <li style={{ color: props.mode === "light" ? "#fff" : "000" }}>
                    <button type="button" onClick={props.handleLightMode} className={`dropdown-item d-flex align-items-center text-${props.mode === "light"}`} data-bs-theme-value="light" aria-pressed="false"><ion-icon name="sunny-outline" ></ion-icon>Light
                    </button>
                </li>
                <li>
                    <button type="button" onClick={props.handleDarkMode} className={`dropdown-item d-flex align-items-center text-${props.mode === "light"}`} data-bs-theme-value="dark" aria-pressed="false"><ion-icon name="moon-outline"></ion-icon>Dark
                    </button>
                </li>
            </ul>
        </div>
    )
}

export default ModeChanger
